export default "__VITE_ASSET__Cglgd3_k__"